<template>
  <div class="q-gutter-lg">
    <Button icon="add" :label="$t('Generate a new token')" @click="openGenerateDialog" />
    <DataTable />

    <GenerateDialog v-model="generateDialogVisible" />
  </div>
</template>

<script>
import Button from '@design-system/components/Button.vue';
import DataTable from './UserClientDataTable';
import GenerateDialog from './UserClientDialogGenerate';

const messages = {
  en: {
    'API Access Tokens': 'API Access Tokens',
    'Generate a new token': 'Generate a new token',
  },
  ja: {
    'API Access Tokens': 'API アクセストークン',
    'Generate a new token': '新しいトークンの作成',
  },
};

export default {
  name: 'UserClients',
  components: { Button, DataTable, GenerateDialog },
  i18n: { messages },
  data() {
    return {
      generateDialogVisible: false,
    };
  },
  methods: {
    openGenerateDialog() {
      this.generateDialogVisible = true;
    },
  },
};
</script>
